import styled, { css } from 'styled-components';
import { ImFloppyDisk } from 'react-icons/im';

import theme from '../../styles/theme';

export const Container = styled.div`
  margin: 0 auto;
  max-width: 1038px;
  width: 100%;
  margin-top: 3%;
`;

export const ContentWrapper = styled.div`
  ${({ display }) =>
    display
      ? css`
          display: ${display};
        `
      : ``};
`;

export const HeaderWrapper = styled.div`
  width: 1038px;
  height: 70px;
  background: ${theme.bgWhite} 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  margin-bottom: 6px;
`;

export const StepsWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  padding: 25px 35px 25px 35px;
`;

export const BodyWrapper = styled.div`
  background: ${theme.bgWhite} 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  margin-bottom: 28px;
  padding: 30px 175px 0px 175px;

  ${({ paddingRight }) =>
    paddingRight
      ? css`
          padding-right: ${paddingRight};
        `
      : ``};

  ${({ paddingLeft }) =>
    paddingLeft
      ? css`
          padding-left: ${paddingLeft};
        `
      : ``};

  ${({ paddingBottom }) =>
    paddingBottom
      ? css`
          padding-bottom: ${paddingBottom};
        `
      : ``};

  ${({ height }) =>
    height
      ? css`
          height: ${height};
        `
      : `height: 550px;`};

  ${({ width }) =>
    width
      ? css`
          width: ${width};
        `
      : `width: 1038px;`};
`;

export const UsuarioWrapper = styled.div`
  ${({ borderBottom }) =>
    borderBottom
      ? css`
          border-bottom: ${borderBottom};
        `
      : `border-bottom:none`};

  color: ${theme.grey410};
  display: table-caption;
  padding-bottom: 30px;
  margin-bottom: 30px;
`;

export const ContatoWrapper = styled.div`
  color: ${theme.grey410};
`;

export const FooterWrapper = styled.div`
  max-width: 1038px;
  width: 100%;
  height: 70px;
  border-radius: 5px;
  opacity: 1;
  display: flex;
  justify-content: space-between;
`;

export const SaveButtonsWrapper = styled.div`
  ${({ display }) =>
    display
      ? css`
          display: ${display};
        `
      : ``};
`;

export const IconSalvar = styled(ImFloppyDisk)`
  margin-right: 9px;
`;

export const ContentWarning = styled.div`
  font: 100 14px 'work_sans' !important;
  margin-top: 13px;
  display: flex;
  justify-content: center;
`;
